import FileUpload from 'components/hoc/FileUpload';
import ModalStdHeader from 'components/modals/ModalStdHeader';
import AppStoreContext, { AppStore } from 'contexts/AppStoreContext';
import React, { useContext, useEffect, useState } from 'react';
import { getSubmittalTemplateURL } from 'services/submittalService';
import '../modals.css';
import { product } from 'copy/copy';
import { useTranslator, RichTranslator } from '@bluebeam/react-i18n';
import { ModalStaticProperties } from 'components/ModalPortal/ModalPortal';

interface Props {
  onSubmittalLogSelect: (files: FileList) => Promise<void>;
}

const SubmittalLogUploadModal: React.FC<Props> & ModalStaticProperties = (
  props
) => {
  useEffect(() => {
    getLogTemplateUrl();
  }, []);

  const [templateUrl, setTemplateUrl] = useState<string>('');

  const { actions } = useContext(AppStoreContext);
  const { translate } = useTranslator(['buttons', 'submittalsPage']);

  const getLogTemplateUrl = async (): Promise<void> => {
    const templateUrl = await getSubmittalTemplateURL();
    setTemplateUrl(templateUrl);
  };

  const handleCancelClick = (): void => {
    actions.clearAllModals();
  };

  const handleSubmittalLogSelect = async (files: FileList): Promise<void> => {
    const { onSubmittalLogSelect } = props;

    onSubmittalLogSelect(files);

    handleCancelClick();
  };

  return (
    <div id="sub-log-upload-modal" className="column h100 os">
      <ModalStdHeader
        text={translate('submittalsPage:submittalUpload.title')}
      />
      <div className="h100 px4 pt8 pb9">
        <div className="light font-size-5">
          <p>
            {translate('submittalsPage:submittalUpload.description', {
              product: product.productName,
            })}
          </p>
          <p>
            <RichTranslator
              components={[
                // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label
                <a
                  href={templateUrl}
                  className="underline medium color-primary-dark cursor-pointer"
                  target="_blank"
                  rel="noreferrer"
                />,
              ]}
              variables={{
                product: product.productName,
              }}
              translationKey="submittalsPage:submittalUpload.fileFormat"
            />
          </p>
        </div>
        <div className="row px5 py3 so-vw100 w100 bgd-white-2 justify-between modal__button-row">
          <button
            id="sub-log-upload-modal-cancel-btn"
            className="btn btn-link"
            onClick={handleCancelClick}
          >
            {translate('buttons:cancel')}
          </button>
          <FileUpload
            id="sub-log-upload-modal-file-upload"
            accept=".xlsx"
            onFileSelect={handleSubmittalLogSelect}
            multiple={false}
          >
            {({ openFilePicker }): React.ReactNode => (
              <button
                id="sub-log-upload-modal-upload-btn"
                className="btn btn-primary"
                onClick={openFilePicker}
              >
                {translate('buttons:okay')}
              </button>
            )}
          </FileUpload>
        </div>
      </div>
    </div>
  );
};

SubmittalLogUploadModal.modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  content: {
    padding: '0',
    top: 'calc(50vh - 152px)',
    left: 'calc(50vw - 168px)',
    width: '336px',
    height: '305px',
    borderRadius: '8px',
  },
};

export default SubmittalLogUploadModal;
